// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.FooterCover{
    background-color: #003300;
    color: white;
    text-align: center;
    font-size: 10px;
    padding: 10px;
}
.linkItemz{
    list-style: none;
    text-decoration: none;
    color: white;
}

.copyright{
    padding: 0;
    margin: 0;
}
.copyright p{
    font-size: 15px;
    padding: 0;
    margin: 0;
}

.acredition{    

    padding: 0;
    margin: 0;

}
.acredition p {    

    padding: 0;
    margin: 0;

}`, "",{"version":3,"sources":["webpack://./src/Components/Footer/Footer.css"],"names":[],"mappings":";AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,SAAS;AACb;AACA;IACI,eAAe;IACf,UAAU;IACV,SAAS;AACb;;AAEA;;IAEI,UAAU;IACV,SAAS;;AAEb;AACA;;IAEI,UAAU;IACV,SAAS;;AAEb","sourcesContent":["\n.FooterCover{\n    background-color: #003300;\n    color: white;\n    text-align: center;\n    font-size: 10px;\n    padding: 10px;\n}\n.linkItemz{\n    list-style: none;\n    text-decoration: none;\n    color: white;\n}\n\n.copyright{\n    padding: 0;\n    margin: 0;\n}\n.copyright p{\n    font-size: 15px;\n    padding: 0;\n    margin: 0;\n}\n\n.acredition{    \n\n    padding: 0;\n    margin: 0;\n\n}\n.acredition p {    \n\n    padding: 0;\n    margin: 0;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
